import { c as _c } from "react/compiler-runtime";
import PopoverMenu from '@/components/PopoverMenu';
import ViverseButton from '@/components/ViverseButton';
import IconDiamond from '@/components/assets/icon_diamond.svg';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { useConfigsContext } from '@/context/ConfigsContext';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
import { ChevronDown } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
export default function PremiumPopoverButton(t0) {
  const $ = _c(34);
  const {
    label,
    "data-component": dataComponent
  } = t0;
  const t = useTranslations();
  const {
    appConfig
  } = useConfigsContext();
  const VIVERSE_MARKET_LINK = appConfig?.links?.viverse_market;
  const [menuOpen, setMenuOpen] = useState(false);
  let t1;
  if ($[0] !== menuOpen) {
    t1 = () => {
      setMenuOpen(!menuOpen);
    };
    $[0] = menuOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClickIcon = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("group h-8 min-w-[156px] gap-1 px-4 text-sm md:h-9 md:gap-2 md:px-5 md:text-base", {
      hidden: false
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconDiamond className="size-5 fill-[#FF82FB] group-hover:fill-[#FF5FFA] group-active:fill-[#9D2199] md:size-6" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = <span className="bg-gradient-title-3 group-hover:bg-gradient-btn-hover group-active:bg-gradient-btn-active bg-clip-text text-transparent">{label}</span>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ChevronDown className="size-5 stroke-[#53FFF6] group-hover:stroke-[#1FFFF3] group-active:stroke-[#008D86] md:size-6" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== dataComponent || $[8] !== t4) {
    t6 = <ViverseButton className={t2} variant="extraOutline" data-component={dataComponent}>{t3}{t4}{t5}</ViverseButton>;
    $[7] = dataComponent;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleClickIcon || $[11] !== t6) {
    t7 = <PopoverTrigger asChild={true} onClick={handleClickIcon}>{t6}</PopoverTrigger>;
    $[10] = handleClickIcon;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `${VIVERSE_MARKET_LINK}/activity`;
  let t9;
  if ($[13] !== t) {
    t9 = t("profile-page.premium-popover.purchase-detail");
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t9) {
    t10 = <PopoverMenu.Item className="hover:text-vive-brand-50 hover:bg-transparent"><div className="body-1 text-inherit">{t9}</div></PopoverMenu.Item>;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8) {
    t11 = <Link href={t8}>{t10}</Link>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `${VIVERSE_MARKET_LINK}/subscriptions`;
  let t13;
  if ($[20] !== t) {
    t13 = t("profile-page.premium-popover.manage-subscription");
    $[20] = t;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t13) {
    t14 = <PopoverMenu.Item className="hover:text-vive-brand-50 hover:bg-transparent"><div className="body-1 text-inherit">{t13}</div></PopoverMenu.Item>;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t14) {
    t15 = <Link href={t12}>{t14}</Link>;
    $[24] = t12;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t11 || $[28] !== t15) {
    t16 = <PopoverContent align="end" className="mt-2 border-none bg-transparent p-0"><PopoverMenu className="bg-vive-primary-70/50 rounded-[5px] backdrop-blur-xl"><PopoverMenu.Group>{t11}{t15}</PopoverMenu.Group></PopoverMenu></PopoverContent>;
    $[27] = t11;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== menuOpen || $[31] !== t16 || $[32] !== t7) {
    t17 = <Popover open={menuOpen} onOpenChange={setMenuOpen}>{t7}{t16}</Popover>;
    $[30] = menuOpen;
    $[31] = t16;
    $[32] = t7;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  return t17;
}